import React from 'react';

class FeedbacksMonitor extends React.Component {
    render() {
        const { session } = this.props;
        const { data } = session;
        const { feedbacks = [] } = data;

        return (
            feedbacks.map((f, index) => <li className='monitor-feed' key={index}>
                {f.type} - {f.question} {(f.leftLegend && f.rightLegend) && <span>( {f.leftLegend} - {f.rightLegend} )</span> }
                </li>)
        )
    }
}
export default FeedbacksMonitor;